import BaseComponentController from "./base_component_controller"
import { computePosition, autoUpdate, offset, flip, shift } from "@floating-ui/dom"
import { enter, leave } from "../../../../design_system/transitions"

export default class extends BaseComponentController {
  static targets = ["trigger", "menu"]

  static values = {
    placement: { type: String, default: "bottom-end" },
    offset: { type: Number, default: 8 }
  }

  connect() {
    this.updatePosition = this.updatePosition.bind(this)

    document.addEventListener('click', (event) => {
      if (!this.element.contains(event.target) && !this.menuHidden) {
        this.triggerTarget.click()
      }
    }, true)
  }

  toggle(event) {
    event.preventDefault()
    this.menuHidden ? this.show() : this.hide()
  }

  show() {
    if (!this.hasMenuTarget) return
    this.updatePosition()
    this.animateIn()
    this.cleanup = autoUpdate(this.element, this.menuTarget, this.updatePosition)
  }

  hide() {
    if (!this.hasMenuTarget) return
    this.animateOut()

    if (this.cleanup) {
      this.cleanup()
      this.cleanup = null
    }
  }

  updatePosition() {
    computePosition(this.element, this.menuTarget, {
      placement: this.placementValue,
      middleware: [offset(this.offsetValue), flip(), shift()]
    }).then(({ x, y }) => {
      Object.assign(this.menuTarget.style, { left: `${x}px`, top: `${y}px` })
    })
  }

  animateIn() {
    enter(this.element)
    enter(this.menuTarget)
  }

  animateOut() {
    leave(this.menuTarget)
    leave(this.element)
  }

  get menuHidden() {
    return this.menuTarget.classList.contains('hidden')
  }
}
